module.exports = __webpack_public_path__ + "static/media/downloadGPTIcon.b486680d.svg";